import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import { InputNumber } from 'primereact/inputnumber';
import React, { useState } from 'react';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';
import LabelWrapper from '../LabelWrapper.component';

export const WrappedInputNumber = props => {
	const {
		className,
		isInputInvalid,
		dataqa = 'common',
		name,
		onChange,
		onFocus,
		onBlur,
		maxFracionDigits,
		...config
	} = props;

	const [segmentTimeout, setSegmentTimeout] = useState();
	const inputNumberClassName = classNames(className, {
		'invalid-component': isInputInvalid,
	});

	const onInputNumberChange = e => {
		if (isFunction(onChange)) {
			onChange({
				target: {
					name,
					value: e?.value,
				},
			});
		}
	};

	const onValueChange = e => {
		if (segmentTimeout) {
			clearTimeout(segmentTimeout);
		}

		setSegmentTimeout(
			setTimeout(() => {
				Analytics.trackSegmentEvent({
					trackingData: {
						field_type: 'inputnumber',
						field_name_dataqa: `ui-input-${dataqa}`,
					},
					eventType: SegmentEventTypes.UserInputCompleted,
				});
			}, 700)
		);
	};

	const focusHandler = e => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'inputnumber',
				field_name_dataqa: `ui-input-${dataqa}`,
			},
			eventType: SegmentEventTypes.UserInputStarted,
		});

		if (isFunction(onFocus)) {
			onFocus(e);
		}
	};

	const blurHandler = e => {
		Analytics.trackSegmentInputEvent({
			trackingData: {
				field_type: 'inputnumber',
				field_name_dataqa: `ui-input-${dataqa}`,
			},
			eventType: SegmentEventTypes.UserInputCompleted,
			fieldValue: e.target?.value,
		});

		if (isFunction(onBlur)) {
			onBlur(e);
		}
	};

	return (
		<div className="common-ui-input-number" data-qa={`ui-input-${dataqa}`}>
			<InputNumber
				className={inputNumberClassName}
				onChange={onInputNumberChange}
				onValueChange={onValueChange}
				incrementButtonIcon="pi pi-chevron-up"
				decrementButtonIcon="pi pi-chevron-down"
				showButtons
				dataqa={`ui-input-${dataqa}`}
				onFocus={focusHandler}
				onBlur={blurHandler}
				{...config}
			/>
		</div>
	);
};

export const WrappedInputNumberWithLabel = LabelWrapper(WrappedInputNumber);
